<template>
  <div>
    <h1>Не найдено</h1>
  </div>
</template>

<script>
export default {
  name: 'page-not-found'
}
</script>

<style scoped>

</style>
